const merchantTest = {
    path: 'merchantTest',
    component: resolve => require(['@/pages/admin/reviewed/alipay/merchantTest'], resolve),
    meta: {isAccredit: true}
  }

  export default merchantTest
